import {objectToForm} from "object-to-form";
import axios from "axios";

export default class Model {

    constructor(path = null) {
        this.path = path;
        this.values = {};
        this.hidden = [];
    }

    getData(obj = {}, prefix = null){
        let data = {};
        for (const [key, value] of Object.entries(obj)) {
            data[key] = value;
        }
        for (const [key, value] of Object.entries(this.values)) {
            if (!this.hidden.includes(key) && value !== undefined){
                data[key] = value;
            }
        }

        data = prefix ? { [prefix]: data } : data;

        return objectToForm(data);
    }

    clear(){
        for (const [key, value] of Object.entries(this.values)) {
            this.values[key] = Array.isArray(value)? []: null
        }
    }

    create(path){
        return axios.post( path || this.path + 'store', this.getData())
    }
    draft(path){
        return axios.post(path || this.path + 'draft', this.getData())
    }
    update(path){
        return axios.post(path || this.path + 'update/' + this.values.id, this.getData({_method: 'PUT'}))
    }
    save(path = null){
        return this.values.id ? this.update(path): this.create(path);
    }
    destroy(path){
        return axios.delete(path || this.path + 'destroy/' + this.values.id)
    }

}
